// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// AUT-6432: the dashboard's dropdown menus. Kept out of any one component because the
// subheader renders them while the map rail needs the same filter list. The ProjectViewMode
// type itself lives with the other dashboard state types in typings/state/project.ts.

// Single source of truth for the filter dropdown's menu items.
export const ORDER_SORT_FILTER_OPTIONS: { value: ProjectOrderSortFilter; label: string }[] = [
  { value: 'all', label: 'All Projects' },
  { value: 'unassigned', label: 'Unassigned Projects' },
  { value: 'estimate', label: 'Estimate' },
  { value: 'completed', label: 'Completed' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'noLocation', label: 'Location Not Defined' },
];

// The server answers the status filters. "Location Not Defined" is decided on the client from
// the set it already holds (a project with no middlePoint), so its request is the request for
// every project, and the two share one cached set.
export const toRequestFilter = (filter: string): string => (filter === 'noLocation' ? 'all' : filter);

// Inside a folder every project is, by definition, in it - so "Unassigned" says nothing there.
// Derived from the list above rather than retyped, so a filter added to the dashboard reaches
// folders too.
export const FOLDER_ORDER_SORT_FILTER_OPTIONS = ORDER_SORT_FILTER_OPTIONS.filter(
  (option) => option.value !== 'unassigned',
);

export const PROJECT_SORT_OPTIONS: { value: ProjectSortFilter; label: string }[] = [
  { value: 'updatedAtD', label: 'Recent' },
  { value: 'nameA', label: 'A-Z' },
  { value: 'nameD', label: 'Z-A' },
];
